import { Box, styled } from 'components/library';

export const StyledBox = styled(Box)(({ theme, openedFromModal }) => ({
  ...(!openedFromModal && { height: '100vh' }),
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
